import { render } from "./MusicPlayer.vue?vue&type=template&id=8dac8956&scoped=true"
import script from "./MusicPlayer.vue?vue&type=script&lang=js"
export * from "./MusicPlayer.vue?vue&type=script&lang=js"

import "./MusicPlayer.vue?vue&type=style&index=0&id=8dac8956&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dac8956"]])

export default __exports__